// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__75Tcw","inputWrap":"Table_inputWrap__3wQy4","col":"Table_col__2C4p0","bmiTooltip":"Table_bmiTooltip__3dAeU"};